import React, { useContext } from "react";

import {
  IonText,
  IonCard,
  IonCardContent,
  IonItem,
  IonIcon,
  IonLabel,
} from "@ionic/react";

import {
  callOutline,
  personCircleOutline,
  mailOutline,
  fingerPrintOutline,
  logOutOutline,
} from "ionicons/icons";

import { Link } from "react-router-dom";

import Page from "../../components/Page/Page";

import { AccountAvatar } from "../../components/Ui/AccountAvatar";

import { AppContext } from "../../base/AppContext";

import "./style.css";

const Account: React.FC = () => {
  const { user, logout } = useContext(AppContext);
  return (
    <Page name="" back="/page/passages">
      <div className="account-page">
        <div className="user-info">
          <div className="user-info-image">
            <AccountAvatar />
          </div>
          <div className="user-info-title">
            <IonText>
              <h3>{user.name}</h3>
            </IonText>
          </div>
        </div>
        <IonCard>
          <IonCardContent className="no-padding">
            <Link to="/page/my-account-change" className="text-decoration-none">
              <IonItem button lines="full">
                <IonIcon slot="start" icon={personCircleOutline} />
                <IonLabel>
                  Nome
                  <p>{user.name}</p>
                </IonLabel>
              </IonItem>
              <IonItem button lines="full">
                <IonIcon slot="start" icon={mailOutline} />
                <IonLabel>
                  E-mail <p>{user.email}</p>
                </IonLabel>
              </IonItem>
              <IonItem button lines="full">
                <IonIcon slot="start" icon={callOutline} />
                <IonLabel>
                  Telefone
                  <p>{user.phone}</p>
                </IonLabel>
              </IonItem>
              <IonItem button lines="full">
                <IonIcon slot="start" icon={fingerPrintOutline} />
                <IonLabel>
                  CPF
                  <p>{user.cic}</p>
                </IonLabel>
              </IonItem>
            </Link>
            <IonItem button onClick={logout} lines="full">
              <IonIcon slot="start" icon={logOutOutline} />
              <IonLabel>Sair</IonLabel>
            </IonItem>
          </IonCardContent>
        </IonCard>
      </div>
    </Page>
  );
};

export default Account;
